<template>
  <form autocomplete="off" v-on:submit.prevent="submit(form)" class="form">
    <div class="flex form-row">
      <div class="col-6">
        <label for="email">Email Address <span>*</span></label>
        <input id="email" type="text" placeholder="Email Address" name="email"
               v-model="form.email" v-validate="'required|email|max:100'">
        <span v-if="errors.has('email')">{{ errors.first('email') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-6">
        <label for="password">Password <span>*</span></label>
        <input id="password" type="password" name="password" placeholder="Password" ref="password"
               v-model="form.password" v-validate="'required|min:6'" />
        <span class="help">must be at least 6 characters</span><br>
        <span v-if="errors.has('password')">{{ errors.first('password') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-6">
        <label for="password_confirmation">Password Confirmation <span>*</span></label>
        <input id="password_confirmation" type="password" name="password_confirmation" placeholder="Password"
               v-model="form.password_confirmation" v-validate="'required|confirmed:password'"
               data-vv-as="password">
        <span v-if="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</span>
      </div>
    </div>
    <input type="hidden" name="token" id="token" v-model="form.token" v-validate="'required'">
    <div class="flex form-row">
      <button class="body-8" :disabled="pending || errors.any()">Submit</button>
    </div>
  </form>
</template>

<script>
  export default {
    name: 'ResetPasswordForm',

    props: ['pending'],

    data: function () {
      return {
        form: {
          token: this.$route.params.token,
          email: null,
          password: null,
          password_confirmation: null
        },
      }
    },

    methods: {
      submit(form) {
        this.$validator.validateAll().then((valid) => {
          if (valid) {
            this.$emit('submit', form);
          }
        });
      }
    }
  };
</script>
